export default __webpack_public_path__ + "static/testimonial-ved-e4312a21985c25ab8d7336203db8c1f8.png";